import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { api } from '../../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from '../../../components/Loader'
import AdShelfCard from '../../../components/AdShelfCard'

const ShelvesAds = () => {
    const [shelves, setShelves] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)

    const navigate = useNavigate()

    const { name } = useParams()

    useEffect(() => {
        const getShelves = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/stores/${name}/shelves`, { params: { page } })
                console.log(response)
                if (response) {
                    setIsLoading(false)
                    setShelves(response.data.shelves)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data.message)
            }
        }

        getShelves()
    }, [])

    // console.log(shelves)

    return (
        <div className='page-content'>
            <div className="">

                <InfiniteScroll
                    dataLength={() => shelves.length}
                    next={false}
                    hasMore={false}
                >
                    <div className="shelves-container">
                        {isLoading && <Loader />}
                        {!isLoading && shelves.length === 0 && <p className="not-found-msg">No shelves found</p>}
                        {
                            shelves.length > 0 && shelves.map((shelf) => (
                                <div className="project-card-wrapper" key={shelf._id}>
                                    <AdShelfCard shelf={shelf}/>
                                </div>
                            ))
                        }
                    </div>
                </InfiniteScroll>

            </div>
        </div>
    )
}

export default ShelvesAds